export default "__VITE_ASSET__ijgsBBhr__"